import cloneDeep from "lodash/cloneDeep";
import { OptionI } from "./interface";
// import { IUserProfileResponse } from "redux/User/userInterfaces";
// import { useAppSelector } from "../redux/HooksRedux";
import { strings } from "constants/Strings";
export const keyboardUtilityCodes = () => {
  let allowedCodes: number[] = [];

  //allows in the sequeence arrow keys, backspace, tab, enter
  allowedCodes.push(37, 39, 8, 9, 13);
  return allowedCodes;
};

// export function convertToLabelValue(
//   arr: any[],
//   labelKey: string,
//   valueKey: string
// ) {
//   return arr.map((item) => {
//     let formattedItem: OptionI = {
//       value: "",
//       label: "",
//     };
//     if (typeof item === "string") {
//       formattedItem.label = item;
//       formattedItem.value = item;
//     } else {
//       formattedItem.label = item[labelKey];
//       formattedItem.value = item[valueKey];
//     }

//     return formattedItem;
//   });
// }

// export function generateOptions(options: OptionI[]) {
//   return options.map((option) => (
//     <option value={option.value}>{option.label}</option>
//   ));
// }

export function deepCopy(data: any) {
  return cloneDeep(data);
}

export function showValue(value: any) {
  if (typeof value === "boolean") {
    if (value === true) {
      return "Yes";
    } else {
      return "No";
    }
  }
  if (
    value === "" ||
    value === undefined ||
    value === null ||
    (Array.isArray(value) && value.length === 0)
  ) {
    return "--";
  }
  return value;
}

export function checkAccess(permissionsNeeded: string[]) {
  //   const userProfile: IUserProfileResponse = useAppSelector(
  //     (state: any) => state.userProfile
  //   );

  //   if (!userProfile.Role?.permissions) {
  //     return false;
  //   }

  //   if (!permissionsNeeded.length) {
  //     return false;
  //   }

  //   for (let permission of permissionsNeeded) {
  //     if (userProfile.Role.permissions.includes(permission)) {
  //       return true;
  //     }
  //   }

  return true;
}

export function formatDate(isoDateString: string) {
  const date = new Date(isoDateString);
  const options: any = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
}

export function convertToLabelValue(
  arr: any[],
  labelKey: string,
  valueKey: string,
  extraKeys?: string[]
) {
  return arr.map((item) => {
    let formattedItem: OptionI = {
      value: "",
      label: "",
    };
    if (typeof item === "string") {
      formattedItem.label = item;
      formattedItem.value = item;
    } else {
      formattedItem.label = item[labelKey];
      formattedItem.value = item[valueKey];
    }
    formattedItem.extraData = {};
    for (let key of extraKeys || []) {
      formattedItem.extraData[key] = item[key];
    }

    return formattedItem;
  });
}

export const convertBooleanToString = (value: boolean) => {
  if (value === true) {
    return "Yes";
  } else {
    return "No";
  }
};
export function generatefullImageUrl(url: any) {
  let generatedUrl = url;
  if (!url?.startsWith("https") || !url?.startsWith("http")) {
    generatedUrl = strings.base_image_url + url;
  }
  return generatedUrl;
}

// export const convertDateAndTime = (value: string) => {
//   // return moment(value).format("DD/MM/YYYY, HH:mm ");
//   const formattedDate = moment(value).format("DD/MM/YYYY");
//   const formattedTime = moment(value).format("HH:mm")
//   return `📅 ${formattedDate}, ⏰ ${formattedTime}`;

// };

export const calculateDateRange = (
  option: string
): { min: string; max: string } => {
  const now = new Date();
  const today = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  );

  let minDate = today;
  let maxDate = now;

  if (option === "TODAY") {
  } else if (option === "LAST_SEVEN_DAYS") {
    minDate = new Date(today);
    minDate.setUTCDate(today.getUTCDate() - 7);
  } else if (option === "LAST_30_DAYS") {
    minDate = new Date(today);
    minDate.setUTCDate(today.getUTCDate() - 30);
  }

  return {
    min: minDate.toISOString(),
    max: maxDate.toISOString(),
  };
};

export function numberToWords(amount: any): string {
  if (amount === 0) return `Zero Rupees `;

  function convert(num: number): string {
    const units = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "Ten",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    let parts: string[] = [];
    if (num >= 1e9) {
      parts.push(`${convert(Math.floor(num / 1e9))} Arab`);
      num %= 1e9;
    }
    if (num >= 1e7) {
      parts.push(`${convert(Math.floor(num / 1e7))} Crore`);
      num %= 1e7;
    }
    if (num >= 1e5) {
      parts.push(`${convert(Math.floor(num / 1e5))} Lakh`);
      num %= 1e5;
    }
    if (num >= 1000) {
      parts.push(`${convert(Math.floor(num / 1000))} Thousand`);
      num %= 1000;
    }
    if (num >= 100) {
      parts.push(`${convert(Math.floor(num / 100))} Hundred`);
      num %= 100;
    }
    if (num >= 20) {
      parts.push(`${tens[Math.floor(num / 10)]}`);
      if (num % 10 > 0) parts.push(units[num % 10]);
    } else if (num >= 10) {
      parts.push(`${teens[num - 10]}`);
    } else if (num > 0) {
      parts.push(`${units[num]}`);
    }
    return parts.join(" ");
  }

  let integerPart = Math.floor(amount);
  let wholeWordPart = convert(integerPart);
  let result: string = wholeWordPart ? `${wholeWordPart} Rupees` : "";

  let decimalPart = Math.round((amount - integerPart) * 100);
  if (decimalPart > 0) {
    if (wholeWordPart) {
      result += " and ";
    }
    result += `${convert(decimalPart)} Paisa`;
  }

  return `${result}`;
}

export const formatINR = (amount: number) => {
  const num = Number(amount) || 0;
  if (num >= 10000000)
    return `₹${(num / 10000000).toFixed(num % 10000000 ? 2 : 0)}Cr`;
  if (num >= 100000)
    return `₹${(num / 100000).toFixed(num % 100000 ? 2 : 0)}L`;
  if (num >= 1000) return `₹${Math.round(num / 1000)}K`;
  return `₹${num}`;
};